import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
(pdfMake as any).vfs = pdfFonts.pdfMake.vfs;
@Component({
  selector: 'sm-salary-details',
  templateUrl: './salary-details.component.html',
  styleUrls: ['./salary-details.component.scss']
})
export class SalaryDetailsComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public parentdata:any) { }

  ngOnInit(): void {
    console.log(this.parentdata);
    
  }


  generatePaySlip() {
    const paySlipData = this.parentdata.data; // Assuming data is in paySlipDetails array
    const entityInfo = typeof paySlipData.entityInfo == 'string' ? JSON.parse(paySlipData.entityInfo) : paySlipData.entityInfo;
  
    // const formattedFromDate = new Date(paySlipData.salaryFromDate).toLocaleDateString("en-US", { year: 'numeric', month: 'short', day: 'numeric' });
    // const formattedToDate = new Date(paySlipData.salaryToDate).toLocaleDateString("en-US", { year: 'numeric', month: 'short', day: 'numeric' });
    // const formattedCreditDate = new Date(paySlipData.salaryCreditDate).toLocaleDateString("en-US", { year: 'numeric', month: 'short', day: 'numeric' });

    const payPeriodText = 'Pay Period: ' + paySlipData.paid_for


    const earningsBody = [
      ["Component", { text: "Amount", alignment: "right" }],
      ["Gross Salary", { text: paySlipData.currency_symbol + paySlipData.netPayment.toFixed(2), alignment: "right" }],
    ];
    
    // Add perks only if greater than 0
    if (paySlipData.otherPerks > 0) {
      earningsBody.push([paySlipData.perks_type,{ text: paySlipData.currency_symbol + paySlipData.otherPerks.toFixed(2), alignment: "right" } ]);
    }

    
  
  
    const dd:any = {
      content: [
        {
          text: "Pay Slip",
          style: "title",
          alignment: "left",
          margin: [0, 20, 0, 20],
        },
        {
          text: entityInfo.name,
          style: "header",
          alignment: "left",
          margin: [0, 0, 0, 5],
        },
        {
          text: entityInfo.address,
          style: "normal",
          alignment: "left",
          margin: [0, 0, 0, 2],
        },
        {
          text: `Phone:  ${entityInfo.country_code + ' ' + entityInfo.phone}`,
          style: "normal",
          alignment: "left",
          margin: [0, 0, 0, 10],
        },
        {
          canvas: [
              {
                  type: "line",
                  x1: 0,
                  y1: 5,
                  x2: 516,
                  y2: 5,
                  lineWidth: 0.5,
                  lineColor: "#d3d3d3",
              },
          ],
           margin: [0, 0, 0, 10],
      },
        
        {
          text: `Employee Name: ${paySlipData.employee_name}`,
          style: "normal",
          alignment: "left",
          margin: [0, 0, 0, 2],
        },
        {
          text: `Joining Date: ${new Date(paySlipData.date_of_join).toLocaleDateString("en-US", {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
        })}`,
          style: "normal",
          alignment: "left",
          margin: [0, 0, 0, 10],
        },
        {
          text: payPeriodText,
          style: "normal",
          alignment: "left",
          margin: [0, 0, 0, 2],
        },
        {
          text: `Working Days: ${paySlipData.workingDays}`,
          style: "normal",
          alignment: "left",
          margin: [0, 0, 0, 2],
        },
        {
          text: `Paid leave: ${paySlipData.paidLeave}`,
          style: "normal",
          alignment: "left",
          margin: [0, 0, 0, 2],
        },
        {
          text: `Unpaid leave: ${paySlipData.unPaidLeave}`,
          style: "normal",
          alignment: "left",
          margin: [0, 0, 0, 10],
        },
       
        {
          table: {
            widths: ["*", "auto"],
            body: [
              ...earningsBody,
              [{ text: "Total Earnings", bold: true }, { text: paySlipData.currency_symbol + (paySlipData.netPayment + paySlipData.otherPerks).toFixed(2), alignment: "right" }],
            ],
          },
          layout: "lightHorizontalLines",
          margin: [0, 0, 0, 10],
        },
        
        // {
        //   table: {
        //     widths: ["*", "auto"],
        //     body: [
        //       ["Deductions", { text: "Amount", alignment: "right" }],
        //       [paySlipData.deduction_type,{ text: paySlipData.currency_symbol + paySlipData.deduction.toFixed(2), alignment: "right" } ],
        //     ],
        //   },
        //   layout: "lightHorizontalLines",
        //   margin: [0, 0, 0, 10],
        // },
        {
          canvas: [
              {
                  type: "line",
                  x1: 0,
                  y1: 5,
                  x2: 516,
                  y2: 5,
                  lineWidth: 0.5,
                  lineColor: "#d3d3d3",
              },
          ],
           margin: [0, 0, 0, 10],
      },
        {
          table: {
            widths: ["*", "auto"],
            body: [
              ["Net pay",{ text: paySlipData.currency_symbol + (+paySlipData.netPayment + +paySlipData.otherPerks - +paySlipData.deduction).toFixed(2), alignment: "right" }],
            ],
          },
          layout: "lightHorizontalLines",
          margin: [0, 0, 0, 10],
        },
        {
          canvas: [
              {
                  type: "line",
                  x1: 0,
                  y1: 5,
                  x2: 516,
                  y2: 5,
                  lineWidth: 0.5,
                  lineColor: "#d3d3d3",
              },
          ],
           margin: [0, 0, 0, 10],
      },
        // {
        //   text: `Net Pay: ${paySlipData.e_netPayment}`,
        //   style: "netPay",
        //   alignment: "left",
        //   margin: [0, 10, 0, 10],
        // },
        // {
        //   text: `Salary Credited On: ${formattedCreditDate}`,
        //   style: "normal",
        //   alignment: "left",
        //   margin: [0, 0, 0, 5],
        // },
        // {
        //   text: `Notes: ${paySlipData.notes}`,
        //   style: "notes",
        //   alignment: "left",
        //   margin: [0, 0, 0, 5],
        // },
        {
          text: "This is a computer-generated pay slip. No signature is required.",
          style: "footer",
          alignment: "left",
          margin: [0, 20, 0, 0],
        },
      ],
      styles: {
        header: { fontSize: 14, bold: false },
        title: { fontSize: 16, bold: true, color: "#000" },
        subheader: { fontSize: 12, bold: true },
        normal: { fontSize: 10 },
        netPay: { fontSize: 10, bold: true },
        notes: { fontSize: 9, italics: true },
        footer: { fontSize: 8, color: "#727272" },
      },
    };

    let dynamicFields : any = []
    if(paySlipData.deduction > 0){
      dynamicFields = [
        {
          table: {
            widths: ["*", "auto"],
            body: [
              ["Deductions", { text: "Amount", alignment: "right" }],
              [paySlipData.deduction_type,{ text: paySlipData.currency_symbol + paySlipData.deduction.toFixed(2), alignment: "right" } ],
            ],
          },
          layout: "lightHorizontalLines",
          margin: [0, 0, 0, 10],
        },
     ]
    }else {
      dynamicFields = []
    }
    dd.content.splice(dd.content.length - 4, 0, ...(Array.isArray(dynamicFields) ? dynamicFields : [dynamicFields]));
    

    const timestamp = new Date().toISOString().replace(/[-:.]/g, "");
    const fileName = `${paySlipData.employee_name.trim().replace(/\s+/g, "_")}_PaySlip_${timestamp}`;

  
    pdfMake.createPdf(dd).download(fileName);
    // pdfMake.createPdf(dd).open();
  }
  



}
